import React, { useState, useEffect, Component, Fragment } from 'react'
import styled from 'styled-components'
import { withStyles } from '@material-ui/core/styles'
import { FormControl, Select, MenuItem, CircularProgress, TextField, InputAdornment, Menu } from '@material-ui/core'
import BarChart2 from '../charts/BarChart2'
import Cookies from 'js-cookie'
import { BiCaretUp, BiCaretDown } from 'react-icons/bi'
import AskReport from '../AskReport'

const base_url = "https://api.v2.smartdash.com/smartdash-dev/v1/index.cfm/"

const styles = theme => ({
  root: {
    margin: '1em',
    display: 'block'
  },
  description: {
    textAlign: 'center',
    fontSize: '18px',
  },
  loader: {
    marginLeft: '45%',
    marginTop: '30%',
  },
  select: {
    width: '150px',
    color: "#fff",
    border: "1px solid #fff",
    borderRadius: "8px"
  },
})

const StyledTextField = styled(TextField)({
  '& label': {
    color: '#fff',
  },
  '& label.Mui-focused': {
    color: '#18bdfe',
  },
  '& .MuiOutlinedInput-root': {
    color: '#fff',
    borderRadius: "8px",
    '&:hover fieldset': {
      borderColor: '#18bdfe',
    },
    '& fieldset': {
      color: '#fff',
      borderColor: '#fff'
    },
    '&.Mui-focused fieldset': {
      borderColor: '#18bdfe',
      color: '#fff',
    },
  },
  '& .MuiOutlinedInput-input': {
    color: '#fff',
    backgroundColor: 'transparent',
    borderRadius: 4,
  }
})

const StyledTextFieldLT = styled(TextField)({
  '& label': {
    color: '#3d3d3d',
  },
  '& label.Mui-focused': {
    color: '#18bdfe',
  },
  '& .MuiOutlinedInput-root': {
    color: '#3d3d3d',
    borderRadius: "8px",
    '&:hover fieldset': {
      borderColor: '#18bdfe',
    },
    '& fieldset': {
      color: '#3d3d3d',
      borderColor: '#3d3d3d'
    },
    '&.Mui-focused fieldset': {
      borderColor: '#18bdfe',
      color: '#3d3d3d',
    },
  },
  '& .MuiOutlinedInput-input': {
    color: '#3d3d3d',
    backgroundColor: 'transparent',
    borderRadius: 4,
  }
})

const DemographicsModule = (props) => {
  const {darkMode} = props
  const token = Cookies.get("token")
  const [demoData, setDemoData] = useState(null)
  const [selectedDemoData, setSelectedDemoData] = useState(null)
  const [selectedMetric, setSelectedMetric] = useState("Age Range")
  const [anchor, setAnchor] = useState(false)

  const getDemographicsData = () => {
    const request = fetch(`${base_url}/demoByLoc`, {
      headers: {token: token}
    })

    request.then(response => response.json())
    .then(data => {
      if(data) {
        setDemoData(data)
        setSelectedDemoData(data[0].Data)
      } else {
        setDemoData([])
        setSelectedDemoData([])
      }
    })
  }

  useEffect(() => getDemographicsData(), [])

  const openMenu = (e) => {
    const { currentTarget } = e

    setAnchor(currentTarget)
  }

  const handleMenuClose = () => {
    setAnchor(null)
  }

  const renderSelectOptions = () => {
    const metrics = ["Age Range", "Ethnicity", "Household Income"]

    return (
      demoData.map(({MetricType, Key}, i) => {
        if(metrics.indexOf(MetricType) !== -1) {
          return (<MenuItem key={Key} value={MetricType} onClick={() => handleChange(MetricType)}>{MetricType}</MenuItem>)
        }
      })
    )
  }

  const handleChange = (metric) => {
    let newSelected = demoData.filter(({MetricType}, i) => MetricType === metric)

    setSelectedMetric(metric)
    setSelectedDemoData(newSelected[0].Data)

    handleMenuClose()
  }

  if(!selectedDemoData) return <CircularProgress className="home-page-loader"/>
  if(demoData.length < 1 || selectedDemoData.length < 1) return <AskReport home={true} />

  const customersPct = []
  const customersBasePct = []
  const metricValue = []
  const series = []
  const customersLY = []
  const boomerangPct = []

  for (let i = 0; i < selectedDemoData.length; i++) {
    customersPct.push(selectedDemoData.map(item => item.Customers)[i] / selectedDemoData.map(item => item.Customers).reduce((a, b) => a + b, 0) * 100)
    customersBasePct.push(selectedDemoData.map(item => item.Customers_Baseline)[i] / selectedDemoData.map(item => item.Customers_Baseline).reduce((a,b) => a + b, 0) * 100)
    customersLY.push(selectedDemoData.map(item => item.Customers_LY)[i] / selectedDemoData.map(item => item.Customers_LY).reduce((a, b) => a + b, 0) * 100)
    boomerangPct.push(selectedDemoData.map(item => item.Boomerang)[i] / selectedDemoData.map(item => item.Boomerang).reduce((a, b) => a + b, 0) * 100)
    metricValue.push(selectedDemoData[i].MetricValue)
  }

  series.push(
    {
      name: '% of Customers(Current)',
      type: 'column',
      data: customersPct
    },
    {
      name: '% of Customers Baseline',
      type: 'column',
      data: customersBasePct
    },
    {
      name: '% of Boomerang Browsers',
      type: 'column',
      data: boomerangPct
    }
  )


  return (
    <div style={{marginTop: "20px"}}>
      <br/>
      <BarChart2
        data={series}
        height={250}
        categories={metricValue}
        colors={props.darkMode ? ['#00d2e6', '#7483ab', '#d97e82'] : ['#00c9db', '#2f5a7a', '#ff2b34']}
        fixed={true}
        darkMode={props.darkMode}
      />
      <div>
        {darkMode ?
          <StyledTextField
            variant="outlined"
            size="small"
            className="select"
            value={selectedMetric}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <BiCaretDown />
                </InputAdornment>
              )
            }}
            onClick={openMenu}
            style={{marginLeft: "15px"}}
            // style={{width: "200px"}}
          />
        :
          <StyledTextFieldLT
            variant="outlined"
            size="small"
            className="select"
            value={selectedMetric}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <BiCaretDown />
                </InputAdornment>
              )
            }}
            onClick={openMenu}
            style={{marginLeft: "15px"}}
            // style={{width: "200px"}}
          />
        }
        <Menu
          open={Boolean(anchor)}
          anchorEl={anchor}
          onClose={handleMenuClose}
          onChange={handleChange}
        >
          {renderSelectOptions()}
        </Menu>
      </div>
    </div>
  )
}

export default DemographicsModule
